import { Component } from '@angular/core';

@Component({
  selector: 'app-equipment',
  imports: [],
  templateUrl: './equipment.component.html',
  styleUrl: './equipment.component.scss'
})
export class EquipmentComponent {

}
